import React from "react";
import { Link } from "react-router-dom";

import utils from '../../utils.js';

export default function MachineCard({ title, id, imageUrl, timestamp }) {

	function stringDateFrom(timestamp) {
		const date = timestamp.toDate();
		const day = date.getDate();
		const year = date.getFullYear();
		const month = utils.monthIndexToName(date.getMonth());

		return day + " de " + month + " de " + year;
	}
	return (
		<Link className="machine-card" to={`/editor/${id}`}>
			<img
				className="machine-card-image"
				src={imageUrl}
				alt="Diagrama de la máquina"
			/>
			<div className="machine-card-content">
				<div className="machine-card-info">
					<p className="machine-card-title">{title}</p>
					<p className="machine-card-date">{stringDateFrom(timestamp)}</p>
				</div>
			</div>
		</Link>
	);
}
